import Modal from '@components/v2/ui/Modal/Modal';
import LangEnum from '../../../lang/LangEnum';
import { useTranslation } from '../../translation/TranslationContext';

type Props = {
  open: boolean;
  onAccept: () => void;
  onDeny: () => void;
};

const BypassOrderOnApprovalAlertModal = ({ open, onAccept, onDeny }: Props) => {
  const { translate } = useTranslation();

  return (
    <Modal
      isOpen={open}
      size="standard"
      header={{ title: LangEnum.GENERAL_SETTINGS_CONFIRM_SETTING_ACTIVATION }}
      onClose={onDeny}
      footer={{
        primaryAction: { label: LangEnum.GLOBAL_CONFIRM_LABEL, onClick: onAccept },
        secondaryAction: { label: LangEnum.GLOBAL_CANCEL_LABEL, onClick: onDeny },
      }}
    >
      {translate(
        LangEnum.GENERAL_SETTINGS_BYPASS_ORDER_ON_APPROVAL_ON_READY_FOR_DELIVERY_MODAL_MESSAGE,
      )}
    </Modal>
  );
};

export default BypassOrderOnApprovalAlertModal;
